import { trigger, transition, query, style, animate } from '@angular/animations';

export const elemShow = trigger('elemShow', [
  transition(':enter', [style({ height: 0, opacity: 0 }), animate('.4s ease-out', style({ opacity: 1 }))]),
]);
